<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-customer-fleet modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>ค้นหาลูกค้าฟลีต</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="field">
                                    <div class="gadget-search-box">
                                        <b-icon icon="search"></b-icon>
                                        <input type="text" placeholder="ชื่อลูกค้า / เลขประจำตัวผู้เสียภาษี" maxlength="50" v-model="formFilter.keyword" />
                                        <button class="btn btn-main" @click="loadFleetList()">ค้นหา</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

                        <div class="mt-3" v-if="isShowResult">
                            <template v-if="searchResult.length > 0">
                                <perfect-scrollbar>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>ชื่อบริษัท</th>
                                                <th>ที่อยู่</th>
                                                <th>ผู้ติดต่อ</th>
                                                <th>ข้อมูลวางบิล</th>
                                                <th>หมายเหตุ</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in searchResult" :key="index">
                                                <td>
                                                    <span class="main">{{ item.company }}</span>
                                                    <span class="text-nowrap"><b-icon icon="card-text" class="icon"></b-icon> {{ item.taxId }}</span>
                                                </td>
                                                <td>{{ item.address }}</td>
                                                <td>
                                                    <span class="main">{{ item.contactPerson }}</span>
                                                    <span class="text-nowrap"><b-icon icon="telephone" class="icon"></b-icon> {{ item.contactTel }}</span>
                                                </td>
                                                <td>
                                                    <span><strong>วันที่วางบิล:</strong> {{ item.billDate }}</span>
                                                    <span><strong>ระยะเครดิต (วัน):</strong> {{ item.creditPeriod }}</span>
                                                    <span><strong>เงื่อนไขการชำระเงิน:</strong> {{ item.remark }}</span>
                                                </td>
                                                <td>{{ item.remark }}</td>
                                                <td><div class="text-center"><button class="btn btn-sm btn-blue text-nowrap" @click="selectCustomer(item)">เลือก</button></div></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </perfect-scrollbar>

                                <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="searchResult.length" class="mt-4"></paging>
                            </template>

                            <template v-if="searchResult.length === 0">
                                <div class="filter">
                                    <div class="no-data">
                                        <b-icon icon="exclamation-diamond"></b-icon>
                                        <span>ไม่พบลูกค้าเครดิตที่กำลังค้นหา โปรดตรวจสอบ<router-link to="/fleet">รายการลูกค้าฟลีต</router-link>ในร้านของท่าน</span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import ModelKeywordFilter from '@/resources/models/KeywordFilter';
import DBFleet from '@/database/Fleet';

export default {
    data() {
        return {
            isActive: false,
            isShowResult: false,
            isLoading: false,
            formFilter: ModelKeywordFilter.data(),
            searchResult: [],
            activePage: 1,
            pageSize: 10
        };
    },
    props: {
        isDisplay: Boolean
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);
        }
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        filterResult(result) {
            if (this.formFilter.keyword) {
                result = result.filter(x => x.company?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1 
                                            || x.taxId?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                            || x.contactPerson?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                            || x.contactTel?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                            || x.remark?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1);
            }

            return result;
        },
        async loadFleetList() {
            this.isShowResult = false;
            this.isLoading = true;
            this.searchResult = [];

            const result = await DBFleet.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Map and Place into the Object
                this.searchResult = result.content;
            }

            // Done Search
            this.isLoading = false;
            this.isShowResult = true;
        },
        selectCustomer(item) {
            this.$emit('hide', item);
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-customer-fleet {
    max-width: 1000px;

    table {
        font-size: 13px;

        td {
            vertical-align: top;
        }
    }
}
</style>